class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (!element) {
        if (section.id === 'cart-icon-bubble' && parsedState.item_count > 0) {
          const cartIcon = document.querySelector('.cart-icon');
          if (cartIcon) {
            // Remove existing bubble if it exists
            const existingBubble = cartIcon.querySelector('#cart-icon-bubble');
            if (existingBubble) {
              existingBubble.remove();
            }
            
            const bubbleHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
            if (bubbleHTML) {
              cartIcon.insertAdjacentHTML('beforeend', bubbleHTML);
            }
          }
        }
        return;
      }
      if (section.id === 'cart-icon-qty' && parsedState.item_count > 0) {
        const qtyElement = document.getElementById('cart-icon-qty');
        if (qtyElement) {
          const qtyHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          if (qtyHTML) {
            qtyElement.innerHTML = qtyHTML;
          }
        }
      }
      element.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (parsedState.item_count > 0) {
      const qtyElement = document.getElementById('cart-icon-qty');
      if (qtyElement) {
        qtyElement.innerHTML = `<span class="cart-count-spacer">&nbsp;</span>(${parsedState.item_count}) `;
      } else {
        const cartButton = document.querySelector('a.header__icon--cart');
        if (cartButton) {
          const currentContent = cartButton.innerHTML;
          const newContent = currentContent.replace(
            'CART',
            `CART <span id="cart-icon-qty"><span class="cart-count-spacer">&nbsp;</span>(${parsedState.item_count}) </span>`
          );
          cartButton.innerHTML = newContent;
        }
      }
    } else {
      const qtyElement = document.getElementById('cart-icon-qty');
      if (qtyElement) {
        qtyElement.remove();
      }
      
      const cartBubble = document.querySelector('.cart-icon #cart-icon-bubble');
      if (cartBubble) {
        cartBubble.remove();
      }
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        section: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
        section: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
      },
      {
        id: 'cart-icon-qty',
        section: 'cart-icon-qty',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
